import { useEffect, useState } from 'react';

export const MOBILE_VIEWPORT_MQ = '(max-width: 767px)';

/**
 * True when viewport is below Tailwind `md` (768px), aligned with order-page mobile layout.
 */
export function useIsMobileViewport() {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MOBILE_VIEWPORT_MQ).matches : false
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_VIEWPORT_MQ);
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return isMobile;
}
